module.exports = __webpack_public_path__ + "static/media/Zapatería_y_Marroquinería.fef88a55.svg";